export const propertyFixture = (propertyOverride = {}) => ({
  address: '123 Main Street, Irvine, CA 92618',
  valuation: null,
  total_bedrooms: 9,
  total_bathrooms: 8,
  home_square_footage: 1075,
  lot_size: 12,
  structure_type_code: 'Single Family',
  apn: null,
  year_built: 1987,
  unaltered_valuation: 34663,
  is_confirmed: true,
  property_id: '1049089',

  ...propertyOverride,
})
